module.exports = __webpack_public_path__ + "img/gal_22.1607ecf5.png";